// extracted by mini-css-extract-plugin
export var closeButton = "_n9-2";
export var closeButtonIcon = "_n9-3";
export var lightboxContent = "_n9-1";
export var lightboxOverlay = "_n9-0";